import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { post } from "../../utils/api";
import toast from "react-hot-toast";
import reset from "./Media/Login-rafiki.png";
import { Button } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TopBar from "../TopBar";
import Footerr from "../Footerr/Footerr";
import ProgressBar from "./../ProgressBar";

function ResetPassword() {
  const { token } = useParams(); // Access token from URL params
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (password !== confirmPassword) {
        toast.error("Passwords don't match");
        return;
      }
      const response = await post(`/sam/doc/users/reset-password/${token}`, {
        newPassword: password
      });
      toast.success(response.message);
      navigate("/login"); // Redirect to login page after successful password reset
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ProgressBar />
      <TopBar />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 pattern-bg2">
        <div className="max-w-md w-full   p-[42px] bg-[white] rounded-[12px] shadow-lg text-center">
          <img src={reset} alt="Reset Password" className="w-[60%] m-auto" />
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Reset Password
            </h2>
          </div>
          <form className="mt-8 " onSubmit={handleSubmit}>
            <input type="hidden" name="remember" value="true" />
            <FormControl variant="outlined" className="!mt-[16px] !w-full">
              <InputLabel htmlFor="password">🔑 Password</InputLabel>
              <OutlinedInput
                id="password"
                label="🔑 Password"
                name="password"
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                required
                fullWidth
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>
            <FormControl variant="outlined" className="!mt-[16px] !w-full">
              <InputLabel htmlFor="password">🔑 Confirm Password</InputLabel>
              <OutlinedInput
                id="password"
                label="🔑 Confirm Password"
                name="password"
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                required
                fullWidth
                placeholder="Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </FormControl>
            <FormControlLabel
              control={<Checkbox onChange={() => handleClickShowPassword()} />}
              label="Show Passwords"
              sx={{ marginRight: "auto", width: "100%", margin: "16px auto" }}
            />
            <div>
              <Button
                type="submit"
                disabled={loading}
                sx={{
                  width: "100%",
                  background: "#fbcb04",
                  color: "black",
                  textAlign: "center",
                  padding: loading ? "16px 10px" : "12px ",
                  marginTop: "2px",
                  "&:hover": {
                    background: "#101c4c",
                    color: "white",
                  },
                }}
              >
                {loading ? (
                  <svg
                    className="animate-spin h-5 w-5 mr-3 text-white"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8zm16 0a8 8 0 01-8 8V24c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8z"
                    ></path>
                  </svg>
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
      <Footerr />
    </div>
  );
}

export default ResetPassword;
